export const SUMMARY_TAB = "summary";
export const CALENDAR_TAB = "calendar";
